import PropTypes from "prop-types";
import Typography from "@shared/v2/Typography";

// Compact header bar for page create/edit flows (Figma "Progress Panel - New Page Flow"):
// a slim row with the flow title on the left and the flow actions on the right.
const PageFlowHeader = ({ actions = null, title }) => (
  <div className="tw-flex tw-items-center tw-justify-between tw-gap-[16px]">
    <Typography variant="headline2">{title}</Typography>
    <div className="tw-flex tw-items-center tw-gap-[16px]">{actions}</div>
  </div>
);

PageFlowHeader.propTypes = {
  actions: PropTypes.node,
  title: PropTypes.string.isRequired,
};

export default PageFlowHeader;
